<companyid-content-wrapper
    assetPath="home/comprehensive-process-notifications"
    classNames="flex-col gap-80px mob:gap-60px tab:gap-60px py-80px tab:px-5 mob:px-5 z-10">
    <div
        class="text-white text-h3-bold relative text-center"
        i18n=":@@comprehensive-process-notifications">
        <companyid-avatar-with-message
            classNames="tab:hidden mob:hidden absolute left-[175px] bottom-[80px]"
            avatarImg="girl"
            [title]="avatarTitle"
            [subtitle]="avatarSubtitle"
            [position]="avatarPosition" />
        Comprehensive <br />
        Process Notifications
    </div>
    <div class="flex gap-x-30px tab:gap-x-80px items-start mob:flex-col mob:gap-y-80px">
        @for (content of comprehensiveContent; let i = $index; track content.title) {
            <div class="flex flex-col text-white w-full relative mt-40px">
                <img
                    [ngSrc]="content.imgPath | asset: 'home/comprehensive-process-notifications'"
                    width="120"
                    height="120"
                    class="absolute left-[-40px] top-[-70px]"
                    alt="content.imgPath" />
                <hr class="my-15px" />
                <span class="mb-15px">0{{ i + 1 }}.</span>
                <span class="mb-5px text-h5-semi-bold">{{ content.title }}</span>
                <span class="text-stroke text-medium-regular">{{ content.subtitle }}.</span>
            </div>
        }
    </div>
    <companyid-contact-and-plans-buttons class="justify-center" />
</companyid-content-wrapper>
